import { AppRoutes } from '@/routes';

/** Top-level router mount point — the actual route tree lives in `routes/index.tsx`. */
export function AppRouter() {
  return <AppRoutes />;
}
